<template>
    <v-card flat v-if="loading">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container v-if="loading == false" class="empty-container"></v-container>
    </v-card>
    <v-card
        flat
        v-else 
    >
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container container--fluid class="onboarding-emails signup-container pb-12">
            <v-card-text class="custom-bold-text px-0 pt-0 mb-2">If you have a privacy policy, please insert the website link. If specified, visitors will be required to accept it while self-onboarding.</v-card-text>
            <v-layout>
                <v-flex d-flex xs12 sm3>
                    <v-card-text class="bold-text tab-title">Privacy Policy Link</v-card-text>
                </v-flex>
                <v-flex d-flex xs12 sm9>
                    <v-layout wrap>
                        <v-card-text class="text-filed">
                            <v-text-field
                                label="Privacy Policy Link"
                                v-model="preparedData.link"
                                hint="Use format https://www.website.com"
                                persistent-hint
                                prepend-icon="link"
                                placeholder="Please Enter"
                                :error-messages="errors($v.preparedData.link)"
                                @blur="$v.preparedData.link.$touch()"
                            >
                            </v-text-field>
                        </v-card-text>
                        <v-card-text class="caption pt-2 pb-8">
                            <!-- Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo soluta provident quae adipisci ipsum optio alias praesentium delectus voluptates quidem. -->
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-alert
                class="pa-2 mt-4 text-left"
                :value="$v.preparedData.$error"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
            >
                    <span class="caption">Please fill out form correctly.</span>
            </v-alert>
            <v-btn
                    :color="saveButtonSettings.color"
                    class="btns-onboard"
                    type="submit"
                    @click.native="savePrivacyPolicy"
                    :loading="saveButtonSettings.loading"
                    :disabled="saveButtonSettings.loading"
                    transition="fade-transition">
                {{saveButtonSettings.text}}
            </v-btn>
        </v-container>
    </v-card>
</template>


<script>
    import ApiService from "@/common/api.service";
    import { validationMixin } from "vuelidate";
    import { url } from "vuelidate/lib/validators";
    import { valMessages, getValMessage } from "@/common/error-messages";

    let validations = {
        preparedData: {
            link: { url }
        }
    }

    export default {
        name: 'EmailSettings',
        props: ['orgid'],
        mixins: [validationMixin],
        validations,
        data() {
            return {
                model: '',
                loading: true,
                contentSettings: [],
                no_data: [null, "", undefined, "null"],
                preparedData: { link: null },
                privacyPolicy: null,
                saveButtonSettings: {
                    color: "cyan darken-3",
                    text: 'Save Changes',
                    loading: false
                },
                savedButtons: [
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false}
                ],
                customToolbar: [
                    ['bold', 'italic', 'underline', 'link'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
            }
        },
        beforeMount() {
            this.getPrivacyPolicy();
        },
        methods: {
            getPrivacyPolicy() {
                this.loading = true;
                ApiService.get('client_on_boarding_setup/privacy_policy')
                    .then(response => {
                        this.loading = false
                        if (
                            !this.no_data.includes(response) &&
                            !this.no_data.includes(response.data)
                        ) {
                            if (response.data.privacy_policy === null) {
                                this.privacyPolicy = null
                                this.preparedData.link = null
                            }
                            if (
                                !this.no_data.includes(response.data.privacy_policy) &&
                                !this.no_data.includes(response.data.privacy_policy.link)
                            ) {
                                this.privacyPolicy = response.data.privacy_policy
                                this.preparedData.link = response.data.privacy_policy.link
                            }
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.error = error
                    });
            },
            savePrivacyPolicy() {
                this.$v.preparedData.$touch();
                if (!this.$v.preparedData.$invalid) {
                    this.saveButtonSettings.loading = true
                    let body = _.cloneDeep(this.preparedData)

                    let method = 'post'
                    let url = '/client_on_boarding_setup/privacy_policy'
                    if (
                        !this.no_data.includes(this.privacyPolicy) &&
                        !this.no_data.includes(this.privacyPolicy.id)
                    ) {
                        method = 'put'
                        url = `/client_on_boarding_setup/privacy_policy/${this.privacyPolicy.id}`
                    }

                    ApiService[method](url, body)
                        .then(response => {
                            this.saveButtonSettings = {
                                color: 'success',
                                text: 'Changes Saved',
                                loading: false
                            }
                            setTimeout(() => {
                                this.saveButtonSettings = {
                                    color: "cyan darken-3",
                                    text: 'Save Changes',
                                    loading: false
                                }
                            }, 3000);
                        })
                        .catch(error => {
                            this.saveButtonSettings = {
                                color: "red",
                                text: 'Save Unsuccessful',
                                loading: false
                            }
                            setTimeout(() => {
                                this.saveButtonSettings = {
                                    color: "cyan darken-3",
                                    text: 'Save Changes',
                                    loading: false
                                }
                            }, 5000);
                        });
                }
            },
            putTemplateContent(type, subject, body, index) {
                this.savedButtons[index].loading = true;
                let data = {
                    type: type,
                    subject: subject,
                    body: body,
                    organization_form_id: this.orgid
                };
                ApiService.put('/client_on_boarding_setup/email_template', data)
                    .then(response => {
                        this.savedButtons[index].color = "success";
                        this.savedButtons[index].text = "Changes Saved";
                        this.savedButtons[index].loading = false;

                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false;
                        }, 3000);
                    })
                    .catch(error => {
                        this.savedButtons[index].color = "red";
                        this.savedButtons[index].text = "Save Unsuccessful";
                        this.savedButtons[index].loading = false;
                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false
                        }, 5000);
                    });
            },
            removeUnderScore(str) {
               return _.upperFirst(str.replace(/_/g, ' '));
            },
            errors: getValMessage(valMessages)(validations)
        }
    }
</script>
<style>
    .custom-bold-text {
        font-weight: bold;
        font-size: 16px;
        color: rgba(0,0,0,.54);
    }

    .empty-container {
        padding: 0px;
    }

    .admin-btn-save {
        margin-bottom: 70px;
    }
</style>
